/* unplugin-vue-components disabled */import { render } from "./ProductionData.vue?vue&type=template&id=475d25a6&scoped=true&ts=true"
import script from "./ProductionData.vue?vue&type=script&lang=ts"
export * from "./ProductionData.vue?vue&type=script&lang=ts"

import "./ProductionData.vue?vue&type=style&index=0&id=475d25a6&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475d25a6"]])

export default __exports__